import type { AssetId } from "@visioni/a3s-schema";
import type { ContractWindow } from "@visioni/a3s-monitoring-contract";

/**
 * A hub-event change: one appended row of the Hub Asset Event Log, carrying the
 * asset it concerns and that event's resolved {@link ContractWindow}s.
 *
 * The feed emits one change per hub-event row (no per-asset dedup), so the
 * consumer sees every event in `change_seq` order. `windows` is already resolved
 * from the event's raw `monitoring` array via `resolveContractWindows`, so the
 * consumer never re-derives it: an empty array is the positively-published
 * "no active contract" value, distinct from the asset having no windows at all.
 */
export type HubEventChange = {
  readonly asset: AssetId;
  readonly windows: readonly ContractWindow[];
};
